<template>
  <div class="why-choose p-5">
    <b-container>
      <b-row class="align-items-center">
        <!-- Left Section -->
        <b-col md="7" class="mb-4 mb-md-0">
          <h2 class="font-weight-bold mb-4">
            Why Choose NextGen Garage Door Repairs?
          </h2>
          <ul class="list-unstyled features-list">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="star"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 
                    3.967a1 1 0 00.95.69h4.178c.969 
                    0 1.371 1.24.588 1.81l-3.385 
                    2.46a1 1 0 00-.364 1.118l1.287 
                    3.966c.3.922-.755 1.688-1.54 
                    1.118l-3.385-2.46a1 1 0 
                    00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 
                    1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 
                    1 0 00.95-.69l1.287-3.967z"
                />
              </svg>
              Licensed, bonded, and insured professionals
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="star"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 
                    3.967a1 1 0 00.95.69h4.178c.969 
                    0 1.371 1.24.588 1.81l-3.385 
                    2.46a1 1 0 00-.364 1.118l1.287 
                    3.966c.3.922-.755 1.688-1.54 
                    1.118l-3.385-2.46a1 1 0 
                    00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 
                    1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 
                    1 0 00.95-.69l1.287-3.967z"
                />
              </svg>
              Same-day emergency service available
            </li>

            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="star"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 
                    3.967a1 1 0 00.95.69h4.178c.969 
                    0 1.371 1.24.588 1.81l-3.385 
                    2.46a1 1 0 00-.364 1.118l1.287 
                    3.966c.3.922-.755 1.688-1.54 
                    1.118l-3.385-2.46a1 1 0 
                    00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 
                    1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 
                    1 0 00.95-.69l1.287-3.967z"
                />
              </svg>
              Serving North Jersey for over 15 years
            </li>
          </ul>
        </b-col>

        <!-- Right Section -->
        <b-col md="5" class="text-center">
          <div class="call-box p-4">
            <div class="icon-wrapper mb-3">
              <svg
                aria-hidden="true"
                class="phone-icon"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="#0d47a1"
                stroke-width="30"
                width="40px"
              >
                <path
                  d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                ></path>
              </svg>
            </div>
            <h4 class="font-weight-bold">Ready to Get Started?</h4>
            <p>Call us today for a free estimate on any of our services</p>
            <a
              href="tel:5514080587"
              class="btn btn-primaryblue btn-lg d-inline-flex align-items-center"
            >
              <svg
                aria-hidden="true"
                class="phone-icon mr-3"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="white"
                stroke-width="20"
                width="16px"
                height="16px"
              >
                <path
                  d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                ></path>
              </svg>
              (551) 408-0587
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "WhyChoose",
};
</script>

<style scoped>
.why-choose {
  background: #fbfbfb;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.features-list li {
  font-size: 1.1rem;
  margin-bottom: 12px;
  display: flex;
  align-items: baseline;
}

.call-box {
  border-radius: 12px;
}

.icon-wrapper {
  background: #e3f2fd;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-icon {
  font-size: 36px;
  color: #0d47a1;
}
.star {
  width: 30px;
  height: 20px;
  color: #ffc107;
  margin-right: 2px;
}

.btn-primaryblue {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: white;
  width: 14rem;
}

.btn-primaryblue:hover {
  background-color: #0a1f5b;
  border-color: #0a1f5b;
  color: white;
}
</style>
